import React, { memo, useContext, useEffect, useState } from 'react';
import { Table, ActionIcon, Select, Pagination, Modal, Box, Title, Text, Group, Button, LoadingOverlay } from '@mantine/core';
import { IoTrashOutline } from "react-icons/io5";
import { FaRegEdit } from "react-icons/fa";
import classes from "./FactoryTableData.module.css";
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../Customhooks/useFetch';
import { baseUrl } from '../../../Constants/constant';
import { useDisclosure } from '@mantine/hooks';
import ViewProductRow from './ViewFactoryrow/ViewFactoryrow.component';
import DeleterowData from './DeleterowData/DeleterowData.component';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { authContext } from '../../../context/AuthProvider.component';

function TableFactory({ editLink, search }: any) {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [refresh, setRefresh] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [selectedFactoryId, setSelectedFactoryId] = useState<any>(null);

  const [confirmDeleteOpened, { open: openConfirmDelete, close: closeConfirmDelete }] = useDisclosure(false);
  const [successModalOpened, { open: openSuccessModal, close: closeSuccessModal }] = useDisclosure(false);
  const [viewModalOpened, { open: openViewModal, close: closeViewModal }] = useDisclosure(false);
  const navigate = useNavigate();
  const { setError }: any = useContext(authContext);
  const token = localStorage.getItem("token");

  const {
    data: datalist,
    loading: listLoading,
    error: getlistError,
    fetchData: gettable,
  } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token,
    },
  });
  const {
    data: deletedata,
    loading: deleteLoading,
    error: getdeleteError,
    fetchData: deletedataapi,
  } = useFetch({
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token,
    },
  });

  useEffect(() => {
    gettable(`${baseUrl}admin/factories?page=${page}&limit=${limit}&search=${search}`);
  }, [page, limit, refresh, search]);

      useEffect(() => {
        if (getlistError) {
          setError(getlistError?.message)
        }
      }, [getlistError]);

  const handleClickEdit = (id: number) => {
    navigate(`${editLink}/${id}`);
  };
  const handleOpenDeleteModal = (id: any) => {
    setSelectedId(id);
    openConfirmDelete();
  };

  const handleView = (id: any) => {
    setSelectedFactoryId(id);
    openViewModal();
  };
  const handleCloseSuccessModal = () => {
    setRefresh(prev =>  prev + 1);
    closeSuccessModal();
  };
  const rows = datalist?.data?.rows?.map((el: any) => (
    <Table.Tr key={el?.id}>
      <Table.Td>{el?.factory_name}</Table.Td>
      <Table.Td>{el?.factory_address}</Table.Td>
      <Table.Td>{el?.location_based_emission} g</Table.Td>
      <Table.Td>{el?.fuel_based_emission} g</Table.Td>
      <Table.Td>{el?.market_based_emission} g</Table.Td>
      <Table.Td>
        <ActionIcon color="#404040" variant="subtle" onClick={() => handleView(el.id)}>
          <MdOutlineRemoveRedEye size={18} />
        </ActionIcon>
        <ActionIcon
          color="#404040"
          variant="subtle"
          onClick={() => handleClickEdit(el.id)}
        >
          <FaRegEdit size={16} />
        </ActionIcon>
        <ActionIcon
          color="red"
          variant="subtle"
          onClick={() => handleOpenDeleteModal(el.id)}
        >
          <IoTrashOutline size={16} />
        </ActionIcon>
      </Table.Td>
    </Table.Tr>
  ));

  const totalPages = Math.ceil((datalist?.data?.count || 0) / limit);
  return (
    <div style={{ padding: '15px 10px 10px 5px' }}>
       <LoadingOverlay
                      visible={listLoading}
                      zIndex={1000}
                      overlayProps={{
                          radius: 'sm',
                          blur: 2,
                          style: {
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%'
                          }
                      }}
                      loaderProps={{ color: '#404040', type: 'bars' }}
                  />

      {/* Error State */}
      {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>}

      {!listLoading && !getlistError && (
        <>
          {/* Table */}
          <Table.ScrollContainer minWidth={1200}>
            <Table striped className={classes.customtable}>
              <Table.Thead>
                <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                  <Table.Th>Factory Name</Table.Th>
                  <Table.Th>Factory address</Table.Th>
                  <Table.Th>Location based Emission factor (g)</Table.Th>
                  <Table.Th>Fuel based Emission factor (g)</Table.Th>
                  <Table.Th>Market based Emission factor (g)</Table.Th>
                  <Table.Th>Action</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {datalist?.data?.rows?.length < 1 ? (
                  <Table.Tr>
                    <Table.Td colSpan={6} style={{ textAlign: 'center', fontSize: '17px' }}>No data Available </Table.Td>
                  </Table.Tr>
                ) : (
                  rows
                )}
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>

          {/* Pagination */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '20px',
            }}
          >
            <Select
              data={[
                { value: '5', label: '05 per page' },
                { value: '10', label: '10 per page' },
                { value: '20', label: '20 per page' },
              ]}
              value={limit.toString()}
              onChange={(value) => setLimit(Number(value))}
              style={{ width: '150px' }}
            />
            <Pagination
              total={totalPages}
              value={page}
              onChange={setPage}
              color="#404040"
            />
          </div>
        </>
      )}
      <DeleterowData
        isConfirmOpen={confirmDeleteOpened}
        isSuccessOpen={successModalOpened}
        closeConfirm={closeConfirmDelete}
        closeSuccess={handleCloseSuccessModal}
        selectedId={selectedId}
        onDeleteSuccess={openSuccessModal}
      />

      <ViewProductRow
        isOpen={viewModalOpened}
        onClose={closeViewModal}
        productId={selectedFactoryId}
      />
    </div>
  );
}

export default memo(TableFactory);
